export default __webpack_public_path__ + "static/media/goopter-casino-automation-process.bd8350b9.png";